<!-- eslint-disable vue/valid-v-for -->
<template>
  <div>
    <v-dialog v-model="estadoComp" persistent scrollable max-width="1200">
      <v-card>
        <v-card-title class="btn_otro">
          <v-row class="d-flex justify-space-between py-2">
            DOCENTE ACTUAL: {{ nombreProfesor }}
            <v-btn fab dark x-small class="btn_style3" @click="$emit('close')"
              ><v-icon dark>fa-times</v-icon></v-btn
            >
          </v-row>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <v-col class="d-flex justify-end pt-0">
            <v-col class="pt-0" cols="12" sm="6" md="4">
              <v-text-field
                label="Buscar"
                v-model="search2"
                append-icon="fa-search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-col>
          <v-data-table
            :headers="headers_profesores"
            :items="filteredDatos"
            :sort-by="['ape1_persona']"
            :sort-desc="[false]"
            class="elevation-1 black--text"
            fixed-header
          >
            <template v-slot:[`item.action_apellido_nombre`]="{ item }">
              <span>
                {{ item.ape1_persona }} {{ item.ape2_persona }}
                {{ item.nombre_persona }}
              </span>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-btn
                class="btn_block_style2 ma-2"
                dark
                small
                v-if="!item.asignado"
                @click="addDocente(item)"
              >
                ASIGNAR
              </v-btn>
            </template>

            <!--ver alumno :disabled="componenteEvento.editar_submodulo !=1" -->
            <template v-slot:[`item.action_ver`]="{ item }">
              <v-btn
                class="btn_ver px-0 mx-0"
                fab
                x-small
                v-if="item.asignado"
                @click="verDocente(item)"
              >
                <v-icon>fa-eye</v-icon>
              </v-btn>
            </template>

            <!--editar alumno  :disabled="componenteEvento.editar_submodulo !=1"  -->
            <template v-slot:[`item.action_editar`]="{ item }">
              <v-btn
                class="btn_editar px-0 mx-0"
                fab
                x-small
                v-if="item.asignado"
                @click="editarDocente(item)"
              >
                <v-icon>fa-pencil-alt</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>

        <span v-if="test">{{ parametros }}</span>
      </v-card>
    </v-dialog>

    <!-- modal TIPO DE DOCENTE -->
    <!-- ESE IF SE AÑADIÓ PORQUE ESTE FORMULARIO USA PROPIEDADES DE PARAMETROS.ITEM QUE NO SIEMPRE EXISTEN GENERANDO ERRORES EN CONSOLA -->
    <!-- EL CASO MÁS COMUN ES LA PRIMERA VEZ QUE USA, CUANDO CARGA LA VISTA -->
    <v-form ref="formDatos" lazy-validation v-if="parametros.item">
      <v-dialog v-model="asignacion" persistent scrollable max-width="1800">
        <v-card>
          <v-card-title class="btn_otro">
            <v-row class="d-flex justify-space-between py-2">
              {{ formTitle }} {{ nombreProfesor }}
              <v-btn
                fab
                dark
                x-small
                class="btn_style3"
                @click="asignacion = false"
                ><v-icon dark>fa-times</v-icon></v-btn
              >
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-card-text>
                  Horario actual de la sección:
                  {{ parametros.item.nombre_seccion }}
                </v-card-text>
                <ag-grid-vue
                  v-if="mostrarHorario"
                  class="ag-theme-balham"
                  :style="{ width: '100%', height: '25vh' }"
                  :columnDefs="columnDefs"
                  :rowData="rowData"
                  :rowHeight="20"
                >
                </ag-grid-vue>
                <v-card
                  v-else
                  cols="12"
                  md="6"
                  class="d-flex justify-center"
                  style="height: 200px; width: 1135px"
                >
                  <span class="mt-2 pa-2 align-center justify-center">{{
                    errorMensaje
                  }}</span>
                </v-card>
                <v-card-text
                  >Horario del docente: {{ nombreProfesor }}</v-card-text
                >
                <ag-grid-vue
                  v-if="rowData2.length > 0"
                  class="ag-theme-balham"
                  :style="{ width: '100%', height: '25vh' }"
                  :columnDefs="columnDefs"
                  :rowData="rowData2"
                  :rowHeight="20"
                >
                </ag-grid-vue>
                <v-card
                  v-else
                  cols="12"
                  md="6"
                  class="d-flex justify-center"
                  style="height: 100px; width: 1135px"
                >
                  <span class="mt-2 pa-2 align-center justify-center"
                    >El docente no tiene cursos asignados</span
                  >
                </v-card>
              </v-col>

              <v-col cols="12" md="6" xs="6" style="margin-top: 10px">
                <span class="font-weight-black">
                  Nivel: {{ parametros.item.desc_nivel }} | Grado:
                  {{ parametros.item.desc_grado }} | Área:
                  {{ parametros.item.desc_area }} | Curso:
                  {{ parametros.item.desc_curso }} | Turno:
                  {{ desc_turno }}
                </span>
                <!-- <v-select
                  label="Tipo de docente"
                  :items="tipo_docente"
                  v-model="editedItem.tipo_docente"
                  :rules="[rul.selectReqTipoDocente]"
                  :disabled="inhabilitarDocente"
                ></v-select> -->
                <v-text-field
                  label="Tipo de Docente"
                  v-model="editedItem.tipo_docente"
                  :disabled="true"
                ></v-text-field>

                <TableButtonComp
                  class="d-flex flex-row-reverse pb-2"
                  textButton="añadir"
                  iconBut="fas fa-plus"
                  :disabled="inhabilitarDocente"
                  @click="addFile"
                />

                <v-data-table
                  :headers="headersComputados"
                  :items="usuarios.slice(0, currentIndex)"
                  class="elevation-1"
                >
                  <template
                    v-for="headerDia in dias"
                    v-slot:[`item.${headerDia.dia}`]="{ item }"
                  >
                    <v-checkbox
                      v-model="
                        item.dias.find((d) => d.id === headerDia.id)
                          .estado_horario
                      "
                      :key="headerDia.value"
                      :disabled="inhabilitarDocente || !item.horaFin"
                      @change="checkboxChanged(item, headerDia)"
                    >
                    </v-checkbox>
                  </template>
                  <template v-slot:item.horaAcademica="{ item }">
                    <v-text-field
                      v-model="item.horaAcademica"
                      type="number"
                      @input="calcularHoraFin(item)"
                      @keypress="validarTecla"
                      :input-mode="'numeric'"
                      :disabled="inhabilitarDocente"
                      :rules="[
                        (value) => !!value || 'Este campo es requerido',
                        (value) =>
                          value >= 0 || 'No se permiten números negativos',
                      ]"
                    ></v-text-field>
                  </template>
                  <template v-slot:item.horaInicio="{ item }">
                    <v-select
                      :items="opcionesUltimasHoras"
                      item-text="text"
                      item-value="value"
                      v-model="item.horaInicio"
                      @change="calcularHoraFin(item)"
                      :disabled="inhabilitarDocente"
                      :rules="[
                        (value) => !!value || 'Por favor selecciona una opción',
                      ]"
                    ></v-select>
                  </template>
                  <template v-slot:item.horaFin="{ item }">
                    <v-text-field
                      v-model="item.horaFin"
                      disabled
                      type="time"
                    ></v-text-field>
                  </template>
                  <template v-slot:[`item.acciones`]="{ item }">
                    <TableButtonComp
                      deleteButton
                      @click="decrementIndex(item)"
                      tooltipText="Eliminar"
                      :disabled="inhabilitarDocente"
                    />
                  </template>
                </v-data-table>
                <div v-if="errores.length > 0" class="error-message">
                  <ul>
                    <li v-for="error in errores" :key="error">{{ error }}</li>
                  </ul>
                </div>

                <v-col cols="12">
                  <v-textarea
                    class="font-weight-black"
                    label="Observación"
                    v-model="editedItem.observacion_asignacion"
                    rows="2"
                    :disabled="inhabilitarDocente"
                  ></v-textarea>
                </v-col>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="btn_style3" dark @click="asignacion = false"
              >Cancelar</v-btn
            >

            <v-btn
              class="btn_block_style2"
              dark
              @click="saveItem"
              v-if="this.editedItem.evento != 'ver'"
              >Guardar</v-btn
            >
          </v-card-actions>
          <span v-if="test">
            Editar Items:<code>{{ editedItem }}</code> <br />
            Horario: <code>{{ Horario }}</code> <br />
            parametros: <code>{{ parametros }}</code> <br />
          </span>
        </v-card>
      </v-dialog>
    </v-form>
    <!----- fin del modal -->
  </div>
</template>
<script>
import axios from "@/helpers/axios";
import { mapMutations, mapActions } from "vuex";
import { AgGridVue } from "ag-grid-vue";
import TableButtonComp from "../../../../components/ComponentsEst/TableButtonComp.vue";
export default {
  name: "modalReasignar",

  components: { TableButtonComp, AgGridVue },

  props: [
    "estadoComp",
    "parametros",
    "id_nivel",
    "id_grado",
    "rowData",
    "docentesFiltrados",
  ],

  mounted() {
    this.loadMain();
    this.getDiasDeLaSemana();
    this.cargarDatosYObtenerDiasHabiles();
  },
  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////

    datoLogin: sessionStorage, // variables de sesion del usuario
    test: false,

    Datos: [],
    formTitle: "",
    nombreProfesor: "",

    Horario: {},
    valid: false,

    asignacion: false,
    inhabilitarDocente: true,
    inhabilitarHorario: true,

    tipo_docente: "",

    editedItem: {},
    parms: {},

    // ag grid
    columnDefs: null,
    diasSemanas: [],
    diasHabiles: [],
    horasDisponibles: [],
    errorMensaje: false,

    //validaciones de formulario
    rul: {
      required: (value) => !!value || "Campo Requerido",
      inputReq: (value) => !!value || "Campo Requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      selectReqTipoDocente: (value) =>
        !!value || "Debe seleccionar un tipo de docente.",
      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo electrónico es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max40: (v) => (v || "").length <= 40 || "Máximo 40 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max80: (v) => (v || "").length <= 80 || "Máximo 80 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",

      email_null: (value) => {
        if (value == "") {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "El correo electrónico es incorrecto";
        }
      },
    },
    search2: "",
    headers_profesores: [
      /* { text: "#", align: "left", sortable: false, value: "id" }, */
      {
        text: "N.° DOCUMENTO DE IDENTIDAD",
        value: "numdoc_persona",
        class: "secondary black--text",
      },
      {
        text: "APELLIDOS Y NOMBRES",
        value: "action_apellido_nombre",
        class: "secondary black--text",
      },
      {
        text: "CELULAR",
        value: "telf_persona",
        class: "secondary black--text",
      },
      {
        text: "CORREO ELECTRÓNICO",
        value: "correo_persona",
        class: "secondary black--text",
      },
      {
        text: "",
        align: "center",
        value: "action",
        sortable: false,
        class: "secondary black--text",
      },

      {
        text: "VER",
        align: "center",
        value: "action_ver",
        sortable: false,
        class: "secondary black--text",
      },

      {
        text: "EDITAR",
        align: "center",
        value: "action_editar",
        sortable: false,
        class: "secondary black--text",
      },
    ],
    headers: [],

    dias: [
      // ESPERO REEMPLAZAR CON LA VARIABLE HORARIO
      { dia: "Lunes", estado_horario: false, id: 1 },
      { dia: "Martes", estado_horario: false, id: 5 },
      { dia: "Miércoles", estado_horario: false, id: 6 },
      { dia: "Jueves", estado_horario: false, id: 7 },
      { dia: "Viernes", estado_horario: false, id: 8 },
      { dia: "Sábado", estado_horario: false, id: 9 },
      { dia: "Domingo", estado_horario: false, id: 0 },
    ],
    usuarios: [
      {
        horaAcademica: "",
        horaInicio: "",
        horaFin: "",
        dias: [
          { dia: "Lunes", estado_horario: false, id: 1 },
          { dia: "Martes", estado_horario: false, id: 5 },
          { dia: "Miércoles", estado_horario: false, id: 6 },
          { dia: "Jueves", estado_horario: false, id: 7 },
          { dia: "Viernes", estado_horario: false, id: 8 },
          { dia: "Sábado", estado_horario: false, id: 9 },
          { dia: "Domingo", estado_horario: false, id: 0 },
        ],
      },
      {
        horaAcademica: "",
        horaInicio: "",
        horaFin: "",
        dias: [
          { dia: "Lunes", estado_horario: false, id: 1 },
          { dia: "Martes", estado_horario: false, id: 5 },
          { dia: "Miércoles", estado_horario: false, id: 6 },
          { dia: "Jueves", estado_horario: false, id: 7 },
          { dia: "Viernes", estado_horario: false, id: 8 },
          { dia: "Sábado", estado_horario: false, id: 9 },
          { dia: "Domingo", estado_horario: false, id: 0 },
        ],
      },
      {
        horaAcademica: "",
        horaInicio: "",
        horaFin: "",
        dias: [
          { dia: "Lunes", estado_horario: false, id: 1 },
          { dia: "Martes", estado_horario: false, id: 5 },
          { dia: "Miércoles", estado_horario: false, id: 6 },
          { dia: "Jueves", estado_horario: false, id: 7 },
          { dia: "Viernes", estado_horario: false, id: 8 },
          { dia: "Sábado", estado_horario: false, id: 9 },
          { dia: "Domingo", estado_horario: false, id: 0 },
        ],
      },
      {
        horaAcademica: "",
        horaInicio: "",
        horaFin: "",
        dias: [
          { dia: "Lunes", estado_horario: false, id: 1 },
          { dia: "Martes", estado_horario: false, id: 5 },
          { dia: "Miércoles", estado_horario: false, id: 6 },
          { dia: "Jueves", estado_horario: false, id: 7 },
          { dia: "Viernes", estado_horario: false, id: 8 },
          { dia: "Sábado", estado_horario: false, id: 9 },
          { dia: "Domingo", estado_horario: false, id: 0 },
        ],
      },
      {
        horaAcademica: "",
        horaInicio: "",
        horaFin: "",
        dias: [
          { dia: "Lunes", estado_horario: false, id: 1 },
          { dia: "Martes", estado_horario: false, id: 5 },
          { dia: "Miércoles", estado_horario: false, id: 6 },
          { dia: "Jueves", estado_horario: false, id: 7 },
          { dia: "Viernes", estado_horario: false, id: 8 },
          { dia: "Sábado", estado_horario: false, id: 9 },
          { dia: "Domingo", estado_horario: false, id: 0 },
        ],
      },
      {
        horaAcademica: "",
        horaInicio: "",
        horaFin: "",
        dias: [
          { dia: "Lunes", estado_horario: false, id: 1 },
          { dia: "Martes", estado_horario: false, id: 5 },
          { dia: "Miércoles", estado_horario: false, id: 6 },
          { dia: "Jueves", estado_horario: false, id: 7 },
          { dia: "Viernes", estado_horario: false, id: 8 },
          { dia: "Sábado", estado_horario: false, id: 9 },
          { dia: "Domingo", estado_horario: false, id: 0 },
        ],
      },
      {
        horaAcademica: "",
        horaInicio: "",
        horaFin: "",
        dias: [
          { dia: "Lunes", estado_horario: false, id: 1 },
          { dia: "Martes", estado_horario: false, id: 5 },
          { dia: "Miércoles", estado_horario: false, id: 6 },
          { dia: "Jueves", estado_horario: false, id: 7 },
          { dia: "Viernes", estado_horario: false, id: 8 },
          { dia: "Sábado", estado_horario: false, id: 9 },
          { dia: "Domingo", estado_horario: false, id: 0 },
        ],
      },
      {
        horaAcademica: "",
        horaInicio: "",
        horaFin: "",
        dias: [
          { dia: "Lunes", estado_horario: false, id: 1 },
          { dia: "Martes", estado_horario: false, id: 5 },
          { dia: "Miércoles", estado_horario: false, id: 6 },
          { dia: "Jueves", estado_horario: false, id: 7 },
          { dia: "Viernes", estado_horario: false, id: 8 },
          { dia: "Sábado", estado_horario: false, id: 9 },
          { dia: "Domingo", estado_horario: false, id: 0 },
        ],
      },
      {
        horaAcademica: "",
        horaInicio: "",
        horaFin: "",
        dias: [
          { dia: "Lunes", estado_horario: false, id: 1 },
          { dia: "Martes", estado_horario: false, id: 5 },
          { dia: "Miércoles", estado_horario: false, id: 6 },
          { dia: "Jueves", estado_horario: false, id: 7 },
          { dia: "Viernes", estado_horario: false, id: 8 },
          { dia: "Sábado", estado_horario: false, id: 9 },
          { dia: "Domingo", estado_horario: false, id: 0 },
        ],
      },
      {
        horaAcademica: "",
        horaInicio: "",
        horaFin: "",
        dias: [
          { dia: "Lunes", estado_horario: false, id: 1 },
          { dia: "Martes", estado_horario: false, id: 5 },
          { dia: "Miércoles", estado_horario: false, id: 6 },
          { dia: "Jueves", estado_horario: false, id: 7 },
          { dia: "Viernes", estado_horario: false, id: 8 },
          { dia: "Sábado", estado_horario: false, id: 9 },
          { dia: "Domingo", estado_horario: false, id: 0 },
        ],
      },
    ],
    currentIndex: 1, //lineas en la tabla
    //variables para el calculo de horario
    desc_turno: "",
    duracion_hora_academica: "",
    hora_de_formacion: "",
    hora_entrada: "",
    hora_salida: "",
    inicio_recreo1: "",
    tiempo_recreo: "",
    inicio_recreo2: "",
    horaInicio: "",
    horaFin: "",
    horaFormacionAjustada: "",
    errores: [],
    //variables para visualizar la carga del docente
    asignacionDocente: [],
    cargaDocente: [],
    //variables cuando tiene mas de 1 hora academica
    registros: [],
    nuevosBloques: [],
    mostrarHorario: false,
    data1: {},
    rowData2: [],
    isEditing: false,
    deleteEvent: "",
  }),

  computed: {
    opcionesUltimasHoras() {
      if (Array.isArray(this.rowData)) {
        const opciones = this.rowData.map((item) => {
          const ultimaHora = item.hora.split(" - ")[1];
          return { text: ultimaHora, value: ultimaHora };
        });
        // Retorna el nuevo array sin el último elemento
        return opciones.slice(0, -1);
      }
      return [];
    },

    headersComputados() {
      let headers = [
        { text: "Horas Académicas", value: "horaAcademica" },
        { text: "Hora de Inicio", value: "horaInicio" },
        { text: "Hora Fin", value: "horaFin" },
      ];
      let eliminar = [{ text: "Eliminar", value: "acciones" }];

      const headersDiasHabiles = this.diasSemanas
        .filter((dia) => this.diasHabiles.includes(dia.id))
        .map((diaHabil) => ({
          text: diaHabil.nombre_dia,
          value: diaHabil.nombre_dia,
        }));

      return [...headers, ...headersDiasHabiles, ...eliminar];
    },
    filteredDatos() {
      if (!this.search2) return this.Datos;

      const searchLowercased = this.search2.toLowerCase();

      return this.Datos.filter((item) => {
        // Convertimos todos los campos relevantes a minúsculas para la búsqueda
        const documentLowercased = item.numdoc_persona.toString().toLowerCase();
        const fullNameLowercased =
          `${item.ape1_persona} ${item.ape2_persona} ${item.nombre_persona}`.toLowerCase();
        const phoneLowercased = item.telf_persona.toString().toLowerCase();
        const emailLowercased = item.correo_persona.toLowerCase();

        // Comprobamos si alguna de las cadenas incluye el término de búsqueda
        return (
          documentLowercased.includes(searchLowercased) ||
          fullNameLowercased.includes(searchLowercased) ||
          phoneLowercased.includes(searchLowercased) ||
          emailLowercased.includes(searchLowercased)
        );
      });
    },
  },

  watch: {
    // cada vez que la pregunta cambie, esta función será ejecutada
    estadoComp() {
      if (this.estadoComp) {
        this.loadMain();
      } else {
        this.limpiarForm();
      }
    },
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    loadMain() {
      //this.limpiarForm();
      // LA PRIMERA VEZ QUE SE LLAMA A ESTE COMPONENTE ES CUANDO NO SE HAN ENVIADO
      // DATOS , POR ESO CREO ESTE IF, PARA EVITAR QUE EJECUTE EL RESTO DE LA FUNCION,
      // PORQUE DARÁ MUCHOS ERRORES PORQUE ASIGNA DATOS QUE NO EXISTEM DADO QUE AUN NO SE HAN USADO LOS SELECTS
      if (!this.parametros.item) return;
      this.errores = [];
      this.editedItem.id_colegio = this.parametros.item.id_colegio;
      this.editedItem.id_ano_lectivo = this.parametros.item.id_ano_lectivo;
      this.editedItem.id_personal = this.parametros.item.id_personal;
      this.editedItem.id_seccion_curso = this.parametros.item.id;
      this.editedItem.id_area = this.parametros.item.id_area;
      this.editedItem.id_seccion = this.parametros.item.id_seccion;
      this.editedItem.id_curso = this.parametros.item.id_curso;
      this.editedItem.id_turno = this.parametros.item.id_turno;
      if (this.parametros.evento == "agregar") {
        this.addItem(this.parametros.item);
        // this.nombreProfesor = "Sin Asignar"
        this.getCargaDocente();
      }

      if (this.parametros.evento == "editar") {
        this.isEditing = true;
        this.editItem(this.parametros.item);
        // this.nombreProfesor = this.parametros.item.nombre_pers;
        this.getAsignacionesCursos();
        this.getCargaDocente();
      }
      this.getHorarioAcademico();
    },

    horaAMinutos(hora) {
      const [horas, minutos] = hora.split(":").map(Number);
      return horas * 60 + minutos;
    },

    validarTecla(event) {
      const charCode = event.which ? event.which : event.keyCode;
      const inputValue = event.target.value;

      // Permitir solo números y evitar 0 al inicio
      if (
        charCode < 48 ||
        charCode > 57 ||
        (charCode === 48 && inputValue.length === 0)
      ) {
        event.preventDefault();
      }

      // Evitar el ingreso de '-' al inicio
      if (charCode === 45 && inputValue.length === 0) {
        event.preventDefault();
      }
    },

    async tiposDocentes() {
      try {
        let response = await axios.get("/mantenimiento/tiposdocentes");
        this.tipo_docente = response.data;
      } catch(e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    obtenerDatosCoincidentes(docentesFiltrados, nuevosDatos) {
      return docentesFiltrados.filter((docente) => {
        const datosNuevos = nuevosDatos.find(
          (nuevo) =>
            nuevo.id === docente.id_personales && nuevo.estado_personal == 1
        );
        if (datosNuevos) {
          Object.assign(docente, datosNuevos);
          return true;
        }
        return false;
      });
    },

    async addItem(item) {
      try {
        let response = await axios.get(
          `/administrativo/personal/profesorView/${item.id_colegio}`
        );
        const nuevosDatos = response.data;
        this.Datos = this.obtenerDatosCoincidentes(
          this.docentesFiltrados,
          nuevosDatos
        );
        this.tiposDocentes();
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async editItem(item) {
      try {
        this.parms = {
          id_colegio: item.id_colegio,
          id_ano_lectivo: item.id_ano_lectivo,
          id_seccion_curso: item.id,
        };
        let resp = await axios.post(
          `/administrativo/asignacionDocenteCurso/list/asignarDocente`,
          this.parms
        );
        this.Datos = this.obtenerDatosCoincidentes(
          this.docentesFiltrados,
          resp.data
        );
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async addDocente(item) {
      this.nombreProfesor = item.nombre_persona + " " + item.ape1_persona;
      this.editedItem.id_personal = item.id;
      this.limpiarArray();
      this.errores = [];
      this.editedItem.evento = "agregar";
      this.formTitle = "ASIGNAR DOCENTE";
      this.asignacion = true;
      this.inhabilitarDocente = false;
      this.inhabilitarHorario = false;
      this.editedItem.observacion_asignacion = "";

      // Buscar el tipo_docente en this.tipoDocente
      console.log(this.tipo_docente, "antesirpo");
      
      const tipoDocenteEncontrado = this.tipo_docente.find(
        (docente) => docente.id === item.tipo_docente
      );
      if (tipoDocenteEncontrado) {
        this.editedItem.tipo_docente = tipoDocenteEncontrado.desc_tipo_docente;
      } else {
        this.editedItem.tipo_docente = "Tipo de docente no encontrado";
      }
console.log(this.tipo_docente, "tiposdoco");

      await this.loadHorario(this.editedItem.evento);
      await this.cargaDocenteRenderizado(item);
    },

    async verDocente(item) {
      this.nombreProfesor = item.nombre_persona + " " + item.ape1_persona;
      await this.cargaDocenteRenderizado(item);
      this.errores = [];
      this.limpiarArray();
      this.editedItem.evento = "ver";
      this.formTitle = "VER DOCENTE";
      this.editedItem.id_personal = item.id;
      this.asignacion = true;
      this.inhabilitarDocente = true;
      this.inhabilitarHorario = true;
      this.editedItem.tipo_docente = this.parametros.item.tipo_docente;
      this.editedItem.observacion_asignacion =
        this.parametros.item.observacion_asignacion;

      // Crear un mapa para agrupar por horaInicio y horaFin
      const grupos = new Map();

      for (let i = 0; i < this.asignacionDocente.data.length; i++) {
        const idDiaSeleccionado = this.asignacionDocente.data[i].id_dia;
        this.horaInicio = this.asignacionDocente.data[i].hora_inicio;
        this.horaFin = this.asignacionDocente.data[i].hora_fin;

        // Crear una clave única basada en la horaInicio y horaFin
        const clave = `${this.horaInicio}-${this.horaFin}`;

        // Verificar si el grupo ya existe
        if (grupos.has(clave)) {
          // Obtener el grupo existente
          const grupoExistente = grupos.get(clave);

          // Verificar que el grupo y el array de días estén definidos
          if (grupoExistente && grupoExistente.dias) {
            // Verificar si el día ya existe en el array de días
            const diaExistente = grupoExistente.dias.find(
              (dia) => dia.id === idDiaSeleccionado
            );

            if (!diaExistente) {
              // Si el día no existe, agregarlo al array de días del grupo existente
              grupoExistente.dias.push({
                dia: this.dias.find((dia) => dia.id === idDiaSeleccionado).dia,
                estado_horario: true,
                id: idDiaSeleccionado,
              });
            }
            // Si el día ya existe, marcarlo como seleccionado
            else {
              diaExistente.estado_horario = true;
            }
          }
        } else {
          // Crear un nuevo grupo si no existe

          const nuevoGrupo = {
            horaAcademica: this.asignacionDocente.data[i].hora_academica,
            horaInicio: this.horaInicio,
            horaFin: this.horaFin,
            dias: this.dias.map((dia) => ({
              dia: dia.dia,
              estado_horario: dia.id === idDiaSeleccionado,
              id: dia.id,
            })),
          };
          grupos.set(clave, nuevoGrupo);
        }
      }

      // Agregar los grupos al array de resultados
      grupos.forEach((grupo) => {
        this.usuarios.unshift(grupo);
      });

      this.loadHorario(this.editedItem.evento);
    },

    async editarDocente(item) {
      this.nombreProfesor = this.parametros.item.nombre_pers;
      this.currentIndex = 1;
      this.limpiarArray();
      this.errores = [];
      this.formTitle = "Actualizar docente :";
      this.editedItem.id_personal = this.parametros.item.id_personal;
      this.editedItem.evento = "editar";
      this.inhabilitarDocente = false;
      this.inhabilitarHorario = false;
      this.asignacion = true;
      this.editedItem.tipo_docente = this.parametros.item.tipo_docente;
      this.editedItem.observacion_asignacion =
        this.parametros.item.observacion_asignacion;
      await this.cargaDocenteRenderizado(item);
      const grupos = new Map();

      for (let i = 0; i < this.asignacionDocente.data.length; i++) {
        const idDiaSeleccionado = this.asignacionDocente.data[i].id_dia;
        const horaInicio = this.asignacionDocente.data[i].hora_inicio;
        const horaFin = this.asignacionDocente.data[i].hora_fin;
        const id_seccion_horario = this.asignacionDocente.data[i].id;
        // Crear una clave única basada en la horaInicio y horaFin
        const clave = `${horaInicio}-${horaFin}`;

        // Verificar si el grupo ya existe
        if (grupos.has(clave)) {
          // Obtener el grupo existente
          const grupoExistente = grupos.get(clave);

          // Verificar que el grupo y el array de días estén definidos
          if (grupoExistente && grupoExistente.dias) {
            // Verificar si el día ya existe en el array de días
            const diaExistente = grupoExistente.dias.find(
              (dia) => dia.id === idDiaSeleccionado
            );

            if (!diaExistente) {
              // Si el día no existe, agregarlo al array de días del grupo existente
              grupoExistente.dias.push({
                dia: this.dias.find((dia) => dia.id === idDiaSeleccionado).dia,
                estado_horario: true,
                id: idDiaSeleccionado,
              });
            } else {
              diaExistente.estado_horario = true;
            }
          }
        } else {
          // Crear un nuevo grupo si no existe
          const nuevoGrupo = {
            horaAcademica: this.asignacionDocente.data[i].hora_academica,
            horaInicio: horaInicio,
            horaFin: horaFin,
            id_seccion_horario: id_seccion_horario,
            dias: this.dias.map((dia) => ({
              dia: dia.dia,
              estado_horario: dia.id === idDiaSeleccionado,
              id: dia.id,
            })),
          };
          grupos.set(clave, nuevoGrupo);
        }
      }

      // Verifica si 'grupos' existe y tiene elementos
      if (grupos && grupos.size > 0) {
        this.currentIndex = grupos.size;
        grupos.forEach((grupo) => {
          this.usuarios.unshift(grupo);
        });
        this.loadHorario(this.editedItem.evento);
        this.Horario = [];
      } else {
        this.currentIndex = 1;
      }
    },

    async loadHorario(evento) {
      try {
        let parms = {
          id_colegio: this.parametros.item.id_colegio,
          id_ano_lectivo: this.parametros.item.id_ano_lectivo,
          id_seccion_curso: this.parametros.item.id,
          evento,
        };
        let resp = await axios.post(
          `/administrativo/asignacionDocenteCurso/horarioSeccion`,
          parms
        );
        this.Horario = resp.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    obtenerNombreDiaPorId(idDia) {
      const diaEncontrado = this.dias.find((dia) => dia.id === idDia);
      return diaEncontrado ? diaEncontrado.dia : null;
    },

    formatearHora(hora) {
      return hora.slice(0, -3);
    },

    checkboxChanged(item, headerDia) {
      // Obtener la carga docente
      const cargaDocenteDocente = this.cargaDocente.filter((asignacion) => {
        return asignacion.id_personal == this.editedItem.id_personal;
      });

      // aca Filtro las asignaciones que tienen el mismo día y hora de inicio
      const horariosRegistrados = cargaDocenteDocente.filter((asignacion) => {
        const horaInicioAsignacion = this.horaAMinutos(
          asignacion.hora_inicio.substr(0, 5)
        );
        const horaFinAsignacion = this.horaAMinutos(
          asignacion.hora_fin.substr(0, 5)
        );
        const nuevaHoraInicio = this.horaAMinutos(item.horaInicio);
        const nuevaHoraFin = this.horaAMinutos(item.horaFin);
        const seSolapa =
          nuevaHoraInicio < horaFinAsignacion &&
          nuevaHoraFin > horaInicioAsignacion;
        return asignacion.id_dia == headerDia.id && seSolapa;
      });

      if (horariosRegistrados.length > 0) {
        this
          .agregarError(`El docente ${horariosRegistrados[0].nombre_persona} ${horariosRegistrados[0].ape1_persona} ya posee
            el curso ${horariosRegistrados[0].desc_curso} asignado a esta hora.`);
      }

      // Verifico si la asignación existe y el checkbox está desmarcado
      if (
        !item.dias.find((d) => d.id === headerDia.id).estado_horario &&
        horariosRegistrados.length > 0
      ) {
        // Eliminar el mensaje de error correspondiente
        this
          .eliminarError(`El docente ${horariosRegistrados[0].nombre_persona} ${horariosRegistrados[0].ape1_persona} ya posee
            el curso ${horariosRegistrados[0].desc_curso} asignado a esta hora.`);
      }
    },

    eliminarError(errorMensaje) {
      const indiceError = this.errores.indexOf(errorMensaje);
      if (indiceError !== -1) {
        this.errores.splice(indiceError, 1);
      }
    },

    //consulto el horario academico por nivel y turno
    async getHorarioAcademico() {
      try {
        let response = await axios.get(
          `/administrativo/horarioAcademico/${this.editedItem.id_colegio}/${this.id_nivel}/${this.editedItem.id_turno}`
        );

        const [horarioAcademico] = response.data;
        if (response.data.length === 0) {
          this.errorMensaje =
            "No tienes un horario académico asignado para este turno y nivel.";
          this.mostrarHorario = false;
          return;
        }
        this.mostrarHorario = true;
        this.duracion_hora_academica = horarioAcademico.duracion_hora_academica;
        this.hora_de_formacion = horarioAcademico.hora_de_formacion;
        this.hora_entrada = horarioAcademico.hora_entrada;
        this.hora_salida = horarioAcademico.hora_salida;
        this.inicio_recreo1 = horarioAcademico.inicio_recreo1;
        this.tiempo_recreo = horarioAcademico.tiempo_de_recreo;
        this.inicio_recreo2 = horarioAcademico.inicio_recreo2;
        this.desc_turno = horarioAcademico.turno.desc_turno;
      } catch (error) {
        this.estadoCalendar = false;
        this.errorMensaje = "No existe registro para este nivel y turno.";
      }
    },

    //---------------------consulto los cursos y horario de profesor al visualizar-----

    async getAsignacionesCursos() {
      try {
        let response = await axios.post(
          "/administrativo/asignacionDocenteCurso/editedItem/",
          this.editedItem
        );
        this.asignacionDocente = response.data;

        if (
          this.asignacionDocente.data &&
          this.asignacionDocente.data.length > 0
        ) {
          this.asignacionDocente.data.forEach((asignacion) => {
            let [horas, minutos] = asignacion.hora_inicio.split(":");
            horas = horas.padStart(2, "0");
            minutos = (minutos || "00").padStart(2, "0");
            asignacion.hora_inicio = `${horas}:${minutos}`;
          });
        } else {
          this.currentIndex = 1;
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    // --------------------consulto la carga horaria de los docentes por seccion// -----

    async getCargaDocente() {
      try {
        let response = await axios.post(
          "/administrativo/asignacionDocenteCurso/editedItem/cargaAcademica",
          this.editedItem
        );

        this.cargaDocente = response.data.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    agregarError(errorMensaje) {
      if (!this.errores.includes(errorMensaje)) {
        this.errores.push(errorMensaje);
      }
    },

    limpiarErroresRelacionados() {
      this.errores = this.errores.filter(
        (e) =>
          !e.includes("hora de inicio") &&
          !e.includes("hora de finalización") &&
          !e.includes("hora de formación") &&
          !e.includes("recreo") &&
          !e.includes("hora")
      );
    },

    calcularHoraFin(item) {
      this.limpiarErroresRelacionados();
      this.errorHoraInicio = "";

      if (item.horaInicio) {
        const horaInicio = item.horaInicio;
        const horasRecreo = this.calcularHorasRecreo(
          this.inicio_recreo1,
          this.tiempo_recreo
        );

        // Verificar si la hora de inicio está dentro del tiempo de recreo
        if (
          horaInicio >= horasRecreo.horaInicioRecreo &&
          horaInicio < horasRecreo.horaFinRecreo
        ) {
          this.agregarError("La hora escogida coincide con el recreo");
          item.horaInicio = "";
          return;
        }

        if (!this.esHoraValida(item.horaInicio)) {
          if (this.horaFormacionAjustada) {
            this.agregarError(
              `Ten en cuenta la hora de formación ajustada: ${this.horaFormacionAjustada}`
            );
          }
          this.agregarError(
            "Por favor, selecciona una hora entre " +
              this.hora_entrada +
              " y " +
              this.hora_salida
          );

          return;
        }

        if (item.horaAcademica) {
          let [intervaloHoras, intervaloMinutos] = this.duracion_hora_academica
            .split(":")
            .map(Number);

          // Multiplica el intervalo por la cantidad de horas académicas
          intervaloHoras *= parseInt(item.horaAcademica);
          intervaloMinutos *= parseInt(item.horaAcademica);

          let [horas, minutos] = horaInicio.split(":").map(Number);

          // Suma los minutos y horas multiplicados al inicio
          minutos += intervaloMinutos;
          horas += intervaloHoras;

          // Ajusta los minutos y horas en caso de que los minutos superen los 59
          while (minutos >= 60) {
            horas += 1;
            minutos -= 60;
          }

          // Asegurarse de que tiene dos dígitos
          horas = horas.toString().padStart(2, "0");
          minutos = minutos.toString().padStart(2, "0");
          const horaFin = `${horas}:${minutos}`;

          // Verificar si la hora de finalización cae dentro del periodo de recreo
          if (
            horaFin > horasRecreo.horaInicioRecreo &&
            horaFin < horasRecreo.horaFinRecreo
          ) {
            this.agregarError(
              "La hora de finalización se encuentra dentro del periodo de recreo."
            );
            item.horaFin = "";
            return;
          }
          if (
            item.horaInicio < horasRecreo.horaInicioRecreo &&
            horaFin > horasRecreo.horaInicioRecreo
          ) {
            this.agregarError(
              "La hora de finalización se encuentra dentro del periodo de recreo y no está permitida."
            );
            item.horaFin = "";
            return;
          }

          if (horaFin > this.hora_salida) {
            this.agregarError(
              "La hora de finalización supera la hora de salida."
            );
            item.horaFin = "";
            return;
          }

          item.horaFin = horaFin;
        } else {
          item.horaFin = null;
        }
      }
    },

    esHoraValida(hora) {
      const horaEntradaAjustada = this.hora_entrada.slice(0, 5);
      const horaFormacion = this.hora_de_formacion.slice(0, 5);
      const horaRecreoInicio = this.inicio_recreo1;
      const tiempoRecreo = this.tiempo_recreo;
      const horaRecreoFin = this.calcularHoraFinRecreo(
        horaRecreoInicio,
        tiempoRecreo
      );

      // Verificar si la hora está dentro del tiempo de recreo
      if (hora > horaRecreoInicio && hora < horaRecreoFin) {
        return false; // No permitir asignar durante el recreo
      }

      // Resto de tu lógica para la asignación en otros horarios
      const esFormacionInexistente = horaFormacion === "00:00:00";
      let [horasFormacion, minutosFormacion] = horaFormacion
        .split(":")
        .map(Number);
      let [horasEntrada, minutosEntrada] = horaEntradaAjustada
        .split(":")
        .map(Number);
      minutosEntrada += minutosFormacion;
      horasEntrada += horasFormacion + Math.floor(minutosEntrada / 60);
      minutosEntrada = minutosEntrada % 60;
      this.horaFormacionAjustada = `${horasEntrada
        .toString()
        .padStart(2, "0")}:${minutosEntrada.toString().padStart(2, "0")}`;

      if (
        esFormacionInexistente &&
        (hora === horaEntradaAjustada || hora === this.horaFormacionAjustada)
      ) {
        return true;
      } else if (
        hora === this.horaFormacionAjustada ||
        (hora > this.horaFormacionAjustada && hora < this.hora_salida)
      ) {
        return true;
      } else {
        return false;
      }
    },

    calcularHorasRecreo(inicioRecreo, duracionRecreo) {
      const horaInicioRecreo = inicioRecreo.slice(0, 5);
      const duracionRecreoAjustada = duracionRecreo.slice(0, 5);

      // eslint-disable-next-line no-unused-vars
      const [horaRecreo, minutosRecreo] = duracionRecreoAjustada
        .split(":")
        .map(Number);
      const [horaEntradaRecreo, minutosEntradaRecreo] = horaInicioRecreo
        .split(":")
        .map(Number);

      let horasRecreoFin =
        horaEntradaRecreo +
        Math.floor((minutosRecreo + minutosEntradaRecreo) / 60);
      let minutosRecreoFin = (minutosRecreo + minutosEntradaRecreo) % 60;

      if (horasRecreoFin >= 24) {
        horasRecreoFin -= 24;
      }

      const horaFinRecreo = `${horasRecreoFin
        .toString()
        .padStart(2, "0")}:${minutosRecreoFin.toString().padStart(2, "0")}`;
      return { horaInicioRecreo, horaFinRecreo };
    },

    calcularHoraFinRecreo(inicioRecreo, duracionRecreo) {
      const horaRecreoAjustada = inicioRecreo.slice(0, 5); // Tomar los primeros 5 caracteres
      const HoraTiempoRecreo = duracionRecreo.slice(0, 5); // Tomar los primeros 5 caracteres

      // Calcula la hora de fin del recreo sumando la hora de inicio del recreo con la duración del recreo

      // eslint-disable-next-line no-unused-vars
      const [horaRecreo, minutosRecreo] =
        HoraTiempoRecreo.split(":").map(Number);
      const [horaEntradaRecreo, minutosEntradaRecreo] = horaRecreoAjustada
        .split(":")
        .map(Number);

      let horasRecreoCalculada =
        horaEntradaRecreo +
        Math.floor((minutosRecreo + minutosEntradaRecreo) / 60);
      let minutosRecreoCalculada = (minutosRecreo + minutosEntradaRecreo) % 60;

      // Ajustar la hora de fin del recreo

      if (horasRecreoCalculada >= 24) {
        horasRecreoCalculada -= 24;
      }

      const horaRecreo1Ajustada = `${horasRecreoCalculada
        .toString()
        .padStart(2, "0")}:${minutosRecreoCalculada
        .toString()
        .padStart(2, "0")}`;
      return horaRecreo1Ajustada;
    },

    // asignar docente
    async saveItem(deleteEvent, id_seccion_horario) {
      this.registros = [];
      this.ajustarHorariosConDias(this.usuarios, this.duracion_hora_academica);

      // Verificar si no hay bloques
      // if (this.nuevosBloques.length === 0) {
      //     this.setEnviarMens({
      //         tipo: "W",
      //         mensaje: "Debe completar los campos y añadir al menos un bloque antes de guardar.",
      //         tiempo: 5000,
      //     });
      //     return; // Evitar que el proceso continúe
      // }

      let todosLosBloquesTienenDiasSeleccionados = true;

      this.nuevosBloques.forEach((nuevos) => {
        let bloqueTieneDiaSeleccionado = false;

        nuevos.dias.forEach((dia) => {
          if (dia.estado_horario) {
            this.registros.push({
              id: dia.id,
              dia: dia.dia,
              estado_horario: dia.estado_horario,
              hora_academica: nuevos.horaAcademica,
              hora_fin: nuevos.horaFin,
              hora_inicio: nuevos.horaInicio,
            });
            bloqueTieneDiaSeleccionado = true;
          }
        });

        if (!bloqueTieneDiaSeleccionado) {
          todosLosBloquesTienenDiasSeleccionados = false;
        }
      });

      // Comprobar si todos los bloques tienen al menos un día seleccionado
      if (!todosLosBloquesTienenDiasSeleccionados) {
        this.setEnviarMens({
          tipo: "W",
          mensaje:
            "Cada bloque debe tener al menos un día seleccionado para poder guardar.",
          tiempo: 5000,
        });
        return; // Evitar que el proceso continúe
      }

      // Si pasa la validación, procede a guardar
      if (this.$refs.formDatos.validate()) {
        try {
          let params = {
            docente: this.editedItem,
            horario: this.registros,
            deleteEvent,
            id_seccion_horario,
          };

          console.log("docente", params.docente);
          console.log("horario", params.horario);
          let resp = await axios.post(
            "/administrativo/asignacionDocenteCurso/",
            params
          );
          this.asignacion = false;
          this.registros = [];
          this.$emit("reloadComp");
          this.$emit("close");
          this.setEnviarMens({
            tipo: `${resp.data.messageT}`,
            mensaje: `${resp.data.message}`,
            tiempo: 3000,
          });
        } catch (error) {
          if (
            error.response &&
            error.response.status === 400 &&
            error.response.data &&
            error.response.data.error
          ) {
            this.setEnviarMens({
              tipo: "E",
              mensaje: "Ya existe un docente asignado en este horario",
              tiempo: null,
            });
          } else {
            this.setEnviarMens({
              tipo: "E",
              mensaje: "Error en la solicitud. Por favor elija otra hora",
              tiempo: null,
            });
          }
        }
      }
    },

    limpiarForm() {
      this.editedItem = {
        evento: null,
        id_colegio: null,
        id_ano_lectivo: null,
        id_us_ing: sessionStorage.id,
        id_seccion_curso: null,
        id_personal: null,
        tipo_docente: null,
        observacion_asignacion: "",
      };
    },

    limpiarArray() {
      this.usuarios.forEach((usuario) => {
        usuario.horaAcademica = "";
        usuario.horaInicio = "";
        usuario.horaFin = "";
        usuario.dias.forEach((dia) => {
          dia.estado_horario = false;
        });
      });
    },

    addFile() {
      this.currentIndex++;
    },

    decrementIndex(item) {
      this.currentIndex--;
      item.horaAcademica = "";
      item.horaInicio = "";
      item.horaFin = "";
      this.deleteEvent = "delete";
      let diasSeleccionados = item.dias.some(
        (dia) => dia.estado_horario === true
      );

      if (diasSeleccionados) {
        this.saveItem(this.deleteEvent, item.id_seccion_horario);
      }
    },

    async getDiasHabiles() {
      let id_colegio = sessionStorage.id_colegio;

      try {
        let response = await axios.get(
          `/administrativo/calendarioAcademico/${id_colegio}`
        );
        this.diasHabiles = response.data[0].dias_seleccionados;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    async getDiasDeLaSemana() {
      try {
        let response = await axios.get("/mantenimiento/diasSemanas");
        this.diasSemanas = response.data;
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    async cargarDatosYObtenerDiasHabiles() {
      try {
        await Promise.all([this.getDiasHabiles(), this.getDiasDeLaSemana()]);
        this.obtenerNombresDiasHabiles();
        this.actualizarColumnas();
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    obtenerNombresDiasHabiles() {
      if (!this.diasHabiles || !this.diasSemanas) {
        return [];
      }

      this.nombresDiasHabiles = this.diasSemanas
        .filter((diaSemana) => this.diasHabiles.includes(diaSemana.id))
        .map((diaHabil) => diaHabil.nombre_dia);
      return this.nombresDiasHabiles;
    },

    // metodo para actualizar las columnas del horario

    actualizarColumnas() {
      if (!Array.isArray(this.nombresDiasHabiles)) {
        return;
      }

      // Columna fija para el horario
      const columnasDinamicas = [
        { field: "hora", headerName: "Hora", pinned: "left", width: 100 },
      ];

      // Y luego para los días hábiles:
      this.nombresDiasHabiles.forEach((dia) => {
        columnasDinamicas.push({
          headerName: dia,
          field: dia.toLowerCase(),
          width: 150,
          flex: 4,
        });
      });

      // Luego establece las columnDefs actualizadas y refresca el grid
      this.columnDefs = columnasDinamicas;
      if (this.gridApi) {
        this.gridApi.setColumnDefs(this.columnDefs);
      }
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },

    ajustarHorariosConDias(bloques, duracionHoraAcademica) {
      this.nuevosBloques = [];
      const sumaHoras = (horaInicio, duracion) => {
        // Valida que las cadenas estén en el formato correcto para HH:MM o HH:MM:SS
        const regex = /^(\d{2}):(\d{2})(?::\d{2})?$/;
        if (!regex.test(horaInicio) || !regex.test(duracion)) {
          return null;
        }

        // Desglosar la hora y la duración en horas y minutos
        const [horasInicio, minutosInicio] = horaInicio.split(":").map(Number);
        const [horasDuracion, minutosDuracion] = duracion
          .split(":")
          .map(Number);

        let minutosTotales = minutosInicio + minutosDuracion;
        let horasTotales =
          horasInicio + horasDuracion + Math.floor(minutosTotales / 60);
        minutosTotales %= 60;
        horasTotales %= 24; // Asegura que las horas sean menores de 24

        return `${horasTotales.toString().padStart(2, "0")}:${minutosTotales
          .toString()
          .padStart(2, "0")}`;
      };

      bloques.forEach((bloque) => {
        const diasCopiados = [...bloque.dias];
        if (bloque.horaAcademica == "1") {
          this.nuevosBloques.push({
            ...bloque,
          });
        } else {
          let horaInicioActual = bloque.horaInicio;
          for (let j = 0; j < bloque.horaAcademica; j++) {
            const horaFin = sumaHoras(horaInicioActual, duracionHoraAcademica);
            const nuevoBloque = {
              ...bloque,
              horaAcademica: 1,
              horaInicio: horaInicioActual,
              horaFin: horaFin,
              dias: j === 0 ? bloque.dias : diasCopiados,
            };

            this.nuevosBloques.push(nuevoBloque);

            horaInicioActual = horaFin;
          }
        }
      });

      return this.nuevosBloques;
    },

    async cargaDocenteRenderizado() {
      try {
        const data1 = {
          id_ano_lectivo: parseInt(this.datoLogin.id_ano_lectivo),
          id_colegio: parseInt(this.datoLogin.id_colegio),
          id_personales: this.editedItem.id_personal,
        };

        const response = await axios.post(
          `/administrativo/asignacionDocenteCurso/cargaDocente`,
          data1
        );

        const formattedData = response.data.data.map((item) => {
          const [horaInicio, horaFin] = item.hora
            .split(" - ")
            .map((h) => h.substring(0, 5));
          return {
            hora: `${horaInicio} - ${horaFin}`,
            lunes: item.lunes,
            martes: item.martes,
            miércoles: item.miercoles, 
            jueves: item.jueves,
            viernes: item.viernes,
            sabado: item.sabado,
            domingo: item.domingo,
            id: item.id_personal,
            id_seccion_horario: item.id,
          };
        });
         
        this.rowData2 = formattedData;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
  },
};
</script>
<style scoped>
.error-message {
  color: red;
  margin-top: 10px;
}

.ag-theme-balham .ag-cell {
  font-size: 12px;
}
</style>
